import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const DialogCarousel = (props: any) => {
  return (
    <Dialog
      open={props.openCarousel}
      onClose={props.handleCloseCarousel}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      sx={{
        '& .MuiPaper-root.MuiPaper-elevation.MuiDialog-paper': {
          width: '1200px',
          maxWidth: '1200px',
          height: '90vh',
        },
      }}
    >
      <DialogContent sx={{ height: '100%' }}>
        <Stack justifyContent={'center'} alignItems={'center'} height='calc(80vh + 30px)'>
          <Box
            component={'img'}
            src='/images/icons/ic-close.svg'
            alt='icon close'
            onClick={props.handleCloseCarousel}
            width={'24px'}
            height={'24px'}
            sx={{
              cursor: 'pointer',
            }}
            position={'absolute'}
            right={'24px'}
            top={'24px'}
            zIndex={1}
          ></Box>
          <Box width={'100%'}>
            <div
              style={{
                paddingBottom: '30px',
                position: 'relative',
              }}
            >
              <Carousel
                additionalTransfrom={0}
                arrows
                autoPlaySpeed={3000}
                centerMode={false}
                className=''
                containerClass='container'
                dotListClass=''
                draggable
                focusOnSelect={false}
                infinite
                itemClass=''
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside
                responsive={{
                  desktop: {
                    breakpoint: {
                      max: 3000,
                      min: 1024,
                    },
                    items: 1,
                  },
                  mobile: {
                    breakpoint: {
                      max: 464,
                      min: 0,
                    },
                    items: 1,
                  },
                  tablet: {
                    breakpoint: {
                      max: 1024,
                      min: 464,
                    },
                    items: 1,
                  },
                }}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots
                sliderClass=''
                slidesToSlide={1}
                swipeable
              >
                {props.imageList
                  .filter((imageFilter: any) => imageFilter.deleted === 0)
                  .map((img: any, index: number) => {
                    return (
                      <img
                        key={index}
                        src={img.src}
                        alt={img.name}
                        style={{
                          display: 'block',
                          maxHeight: '80vh',
                          margin: 'auto',
                          // width: '100%',
                        }}
                      />
                    );
                  })}
              </Carousel>
            </div>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DialogCarousel;
